
import React from 'react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { Course } from '@/types/course';

interface CourseDescriptionProps {
  course: Course;
  additionalInfo?: {
    about?: string;
  } | null;
}

export function CourseDescription({ course, additionalInfo }: CourseDescriptionProps) {
  return (
    <section className="py-6" id="about">
      <h2 className="text-2xl font-bold mb-6">About This Course</h2>
      
      <div className="prose max-w-none mb-8">
        <p>{course.description}</p>
        {additionalInfo?.about && (
          <div className="mt-4">
            <p>{additionalInfo.about}</p>
          </div>
        )}
      </div>
      
      {course.welcome_video_url && (
        <div className="mt-8">
          <h3 className="text-lg font-semibold mb-4">Course Preview</h3>
          <div className="bg-black/5 rounded-xl overflow-hidden border">
            <AspectRatio ratio={16 / 9}>
              <iframe
                src={course.welcome_video_url}
                title="Course Preview"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            </AspectRatio>
          </div>
        </div>
      )}
    </section>
  );
}
